module.exports = __webpack_public_path__ + "img/equipo_16-9_640.754b92e3.jpg";